import { DonationRecurrenceInterval, TransactionType } from '~/types/graphql'

export const getDonationRecurrenceIntervalLabel = (
  interval: DonationRecurrenceInterval
) => {
  switch (interval) {
    case DonationRecurrenceInterval.Monthly:
      return 'Monthly'
    case DonationRecurrenceInterval.Quarterly:
      return 'Quarterly'
    case DonationRecurrenceInterval.TwiceAYear:
      return 'Biannually'
    case DonationRecurrenceInterval.Yearly:
      return 'Yearly'
    default:
      return 'One-Time'
  }
}

export const getTransactionTypeLabel = (type: TransactionType) => {
  switch (type) {
    case TransactionType.Card:
      return 'Card'
    case TransactionType.BankAccount:
      return 'Bank Account'
    case TransactionType.DonorAdvisedFund:
      return 'Donor Advised Fund'
    case TransactionType.Other:
      return 'Other'
    default:
      return 'Offline'
  }
}
